export default __webpack_public_path__ + "static/media/logo-fiawec.ed8d7d5a.png";